export default {
    header: {
        performanceReviewSetup: '360 Feedback Setup',
        selfAssessmentPerformanceReviewSetup: 'Self-Assessment Setup',
        configureAndLaunch: 'Configure and launch comprehensive performance reviews',
        saveSettings: 'Save your settings',
    },
    scheduleOptions: {
        title: 'Scheduling Options',
        sendImmediately: 'Send immediately',
        sendLater: 'Schedule for later',
        daysAllowed: 'Days allowed to complete the 360 Feedback',
        daysAllowedSelfAssessment: 'Days allowed to complete the self-assessment',
        days: 'days',
        recommended: 'Recommended: 7-21 days',
    },
    automatedReminders: {
        title: 'Automated Reminders',
        description: 'Enabled automated reminders',
        sevenDaysBefore: '7 days before deadline',
        treeDaysBefore: '3 days before deadline',
        onDeadlineDay: 'On deadline day',
        delayOfDays: '{{days}} days before the deadline',
        outsideWindowUnavailable:
            'A reminder cannot be sent before the review starts. With a response window of {{window}} days, a delay longer than {{window}} days is unavailable.',
        outsideWindowTitle: 'Reminder delay too long',
        outsideWindow:
            'The response window is {{window}} days, so these reminder delays were refused: {{delays}}. Choose a delay within the window, then save again.',
    },
    resultsVisibility: {
        title: 'Results Visibility',
        managerAccess: '{{managerLabelCapitalized}} Access',
        fullAccess: 'Full Access',
        viewAllScore: 'View all scores and ratings',
        readAllComments: 'Read all comments and feedback',
        accessIndividual: 'Access individual reviewer responses',
        noIndividualAnswer:
            'Answers stay anonymous: no one knows who wrote what. Results only show from {{minimum}} responses.',
        employeeAccess: 'Employee Access',
        noAccessMessage: 'The employee has no access to the results.',
        revieweeSeesNamedAnswers:
            'The person being evaluated will see the answers, with the names of the respondents.',
    },
    customizeSurveyEmail: {
        title: 'Customize the Review Email',
        selectLanguage: 'Select Language',
        titleLabel: 'Title',
        enter: 'Enter',
        message: 'Message',
        typeHere: 'Type here',
        testLaunchEmail: 'Test Launch Email',
        testEmailAddressPlaceholder: 'Email address',
        testEmailTitleMin: 'Title must be at least 5 characters long',
        testEmailRequired: 'Email address is required',
        testEmailInvalid: 'Please enter a valid email address',
        testEmailMessageRequired: 'Message is required',
        testEmailSending: 'Sending test email...',
    },
    testEmail: {
        successTitle: 'Test Email Sent',
        successMessage: 'Test email sent successfully',
    },
    saveSettingsSuccessTitle: 'Settings saved',
    saveSettingsSuccessMessage: 'Your schedule settings have been saved successfully',
    launchReview: {
        title: "You're all set. All that's left is to activate the review!",
        launch: 'Activate Review',
    },
    updateReview: {
        title: "You're all set. Update the review!",
        launch: 'Update Review',
    },
    validation: {
        daysRequired: 'Days to complete is required',
        daysMin: 'Must be at least 1 day',
        daysMax: 'Cannot exceed 365 days',
        schedulingRequired: 'Please select a scheduling option',
        languageRequired: 'Please select a language',
        emailTitleRequired: 'Email title is required',
        emailTitleMin: 'Email title must be at least 5 characters',
        emailTitleMax: 'Email title cannot exceed 100 characters',
        emailMessageRequired: 'Email message is required',
        emailMessageMax: 'Email message cannot exceed 3000 characters',
    },
};
